import React from 'react';

const SubAbout = () => {
  return (
    <section className='sub-text-box' id='sub-text-box'>
      <h1>About Us</h1>
      <p>KNOW US; KNOW PEACE.</p>
    </section>
  );
};

export default SubAbout;
